import WebCryptoAesCbc from './WebCryptoAesCbc';
import JsCryptoAesCbc from './JsCryptoAesCbc';
require('core-js/fn/promise');

class CryptoAesCbc {

	constructor() {

		// acquire a promise to the correct crypto implementation.
		this.crypto = WebCryptoAesCbc.isSupportedAsync()
		.then( (webCryptoSupported ) => {
			if( webCryptoSupported ) {
				return new WebCryptoAesCbc();
			}
			else {
				return new JsCryptoAesCbc();
			}
		})
		.catch( () => {
			// fallback
			return new JsCryptoAesCbc();
		});
	}

	createKey( key ) {
		return this.crypto.then( (crypto) => {
			return crypto.createKey(key);
		});
	}

	decrypt( cryptoKey, iv, cypherText ) {
		return this.crypto.then( (crypto) => {
			return crypto.decrypt(cryptoKey, iv, cypherText);
		});
	}
}

export default CryptoAesCbc;



// WEBPACK FOOTER //
// ./src/aes/CryptoAesCbc.js